module.exports = __webpack_public_path__ + "img/trash.f991d55f.svg";